export default "__VITE_ASSET__BhwY4JN$__"